
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image, ScrollTracking } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Die Sportgastro, eine Schwestergesellschaft des SC Bern, gibt es seit 18
  Jahren, und sie hat eine eindrückliche Lohnliste: 110 Festangestellte und 800
  Aushilfen arbeiten in den Sportgastro-Betrieben. Während der Spielzeiten der
  Mutzen werden in der Stadiongastronomie inklusive der Logen bis zu 2000
  Personen verköstigt. Aber ihr Gastroengagement reicht übers Eisstadion hinaus:
  Das Beef Steakhouse in der Kramgasse ist das eleganteste der Restaurants in
  der Stadt Bern und mit knapp 100 Plätzen auf zwei Stockwerken das kleinste.
  Andere Lokale sind grösser: Das Caledonia bei der Postfinance-Arena verfügt
  über 240 Plätze, das Mappamondo in der Länggasse über 150 Plätze im
  Restaurant, dazu kommen 50 Barplätze und 40 Plätze in der Kegelbahn, und im
  grossen Saal mit Theaterbühne hat es Platz für bis gegen 200 Leute. Mit dem
  Lago in Hinterkappelen wagte die Sportgastro 2016 den Schritt über die
  Stadtgrenzen hinaus, das Lokal am Wohlensee zählt 130 Innenplätze und 200
  Aussenplätze.
    </p>
    <ScrollTracking label='content50' mdxType="ScrollTracking" />
    <Image file={require('images/sportgastro_2.jpg')} source='Im Beef in der Kramgasse spielt Fleisch die Hauptsache. Es ist mit 100 Plätzen eines der kleinsten Lokale der SCB-Tochter. Bild: Nicole Philipp' mdxType="Image" />
    <p>
  «Wir müssen uns nicht vergrössern, aber wir evaluieren unsere Chancen und
  übernehmen Lokale, wenn sie passen», sagt Sven Rindlisbacher von der
  Sportgastro. Die Gastrobranche werde kurzlebiger, und sie müssen sich immer
  wieder anpassen. So führten sie auch schon vier Restaurants auf dem
  Messegelände, die jetzt beim Zürcher Frauenverein angesiedelt sind. Oder bis
  2016 die Restaurants in den Stadtberner Sportanlagen, welche nun von der
  Bonsoir-Gruppe geführt werden. Daraus zogen sie sich wegen der
  Wetterabhängigkeit und des Kostendrucks zurück.
    </p>
    <p>
  Das Take-away-Konzept The Beef Burger verfügte über zwei Lokale: Der Standort
  in der Welle 7 hat sich bewährt, derjenige in der Marktgasse schloss Ende
  Januar. In Foodcourts der Einkaufszentren Wankdorf oder Westside zu eröffnen,
  sei keine Option. «Dort gibt es schon Läden, die Burger verkaufen. Und so nah
  an der Konkurrenz wollen wir nicht sein», erklärt Rindlisbacher. Ende 2021
  steht ein neues Projekt an: In Ostermundigen, just an der Stadtgrenze, werden
  sie zwei Konzepte im Bären-Tower durchführen, eines im Erdgeschoss und eines
  im neunten Stock mit Dachterrasse. Dort sollen rund 100 Gäste Platz finden.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;